export default __webpack_public_path__ + "static/media/Header-Logo.dbd90c12.svg";